import { Component, OnDestroy, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';

import { ActivatedRoute, Params, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { formatDate } from '@angular/common';
import * as moment from 'moment';
import { ConsumersService } from '../../consumers.service';
@Component({
  selector: 'app-loyalty-point-history',
  templateUrl: './loyalty-point-history.component.html',
  styleUrls: ['./loyalty-point-history.component.scss']
})
export class LoyaltyPointHistoryComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {
  data;
  columnDefs;
  rowData: any = [];
  private gridApi;
  private gridColumnApi;
  dateSelected: any;
  consumerDetails:any;
  userId: any;
  historyDays = [{ days: 30, value: 'Last 30 days' }, { days: 60, value: 'Last 60 days' }, { days: 90, value: 'Last 90 days' }];
  selectedDays = this.historyDays[0].days;
  constructor(private activeRoute: ActivatedRoute,private router: Router, private consumersService: ConsumersService) {
    super();
    this.userId =this.activeRoute.snapshot.params.userId;
    this.getUserDetails();
    this.initGrid();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

  }

  getUserDetails(){
    this.consumersService.getConsumerbyId(this.userId).subscribe(
      res => {
      let data: any = res;
      this.consumerDetails = data.data;
      })
  }

  initGrid() {
     this.consumersService.LoyaltyPointHistory(this.userId,this.selectedDays).subscribe(res => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
        for(var i=0;i<resData.length;i++) {
         if(resData[i].pointsAccumulated>0){
          resData[i].pointsAddedOrRemoved= '+' + resData[i].pointsAccumulated;
         }else if(resData[i].pointsDeducted>0){
          resData[i].pointsAddedOrRemoved= '-' + resData[i].pointsDeducted;
         }else if(resData[i].pointsDeducted==0 && resData[i].pointsAccumulated==0){
          resData[i].pointsAddedOrRemoved= resData[i].pointsDeducted;
         }

        }
        this.rowData = resData;
        this.setGrid(resData);
      }
    })
  }



  // History grid initialization
  setGrid(data: any) {
    this.rowData = data;
    this.columnDefs = [
      { field: 'adminDisplayName', headerName: 'Modified By', width: 250 },
      { field: 'createdDatetime', headerName: 'Modified Date' , width: 300, 
         cellRenderer: (data) => 
          { 
            return moment(data.value).format("MM/DD/YYYY");

          }
        },
      
      { field: 'role', headerName: 'Role', width: 250},
//       { field: 'pointsAddedOrRemoved', headerName: 'Points Added/Removed', width: 400, cellRenderer: (data) =>{

//        if(data.value!==0 && data.value.startsWith('+') ){
// return `<span class="text-success">${data.value}</span>`
//        }else if(data.value!==0 && data.value.startsWith('-')){
//         return `<span class="text-danger">${data.value}</span>`
//        } else if(data.value==0){
//         return `<span >${data.value}</span>`
//        }

//       }},
      { field: 'pointsAccumulated', headerName: 'Points Added', width: 400, cellRenderer: (data) =>{

        if(data.value) {
          return `<span class="text-success">+${data.value}</span>`
        }
        // else {
        //   return `<span class="text-success">${data.value}</span>`
        // }
      }},
      { field: 'pointsDeducted', headerName: 'Points Removed', width: 400, cellRenderer: (data) =>{

         if(data.value) {
          return `<span class="text-danger">-${data.value}</span>`
        }
        // else {
        //   return `<span class="text-success">${data.value}</span>`
        // }

      }},
      { field: 'currentPoints', headerName: 'Current Balance', width: 250}
    ];
  }

  exportData() {
    let header = this.columnDefs.map(columnDef => {
      let headerName = columnDef.headerName;
      return headerName;
      });
      let params: any = {
      fileName: 'Loyalty-Point-History.csv',
      //columnSeparator: ';',
      skipHeader: true,
      columnKeys: this.columnDefs.map(c => c.field || c.colId).filter(c => !!c)
      };
      params.customHeader = header.join(params.columnSeparator);
      params.processCellCallback = (cellParams) => {
      // 
      if(cellParams && cellParams.column.colId === '') {
        return ''; //apply your timestamp formatter 
      }else if(cellParams && cellParams.column.colId === 'createdDatetime') {
        return moment(cellParams.value).format('MM/DD/YYYY')
      }
        else return cellParams.value // no formatting
      }
      this.gridApi.exportDataAsCsv(params);
  }
  // onSelectionhistoryChanged(e) {

  // }


  changehistory(e) {
    this.consumersService.LoyaltyPointHistory(this.userId,this.selectedDays).subscribe(res => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
        // resData.forEach(x => {
        //   x.modifiedDttm = formatDate(x.modifiedDttm, 'MM-dd-yyyy', 'en');
        // });
        this.rowData = resData;
        this.setGrid(resData);
      }
    })
  }
}
